import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import CopyField from '~/components/Fields/CopyField';
import { DoseStatisticsRow } from '~/containers/viewer/table-panel/DoseStatisticsTable';

export default function DoseStatisticsTableRow({
    row,
}: {
    row: DoseStatisticsRow;
}) {
    return (
        <TableRow key={row.id}>
            <TableCell>
                <Box display="flex" alignItems="center">
                    <Box
                        height={10}
                        width={10}
                        borderRadius="100%"
                        bgcolor={row.color}
                        mr={2}
                    />
                    <Typography fontSize={13}>{row.structure}</Typography>
                </Box>
            </TableCell>
            <TableCell>
                <CopyField label={row.minDoseGy.toFixed(1)} size={12} />
            </TableCell>
            <TableCell>
                <CopyField label={row.maxDoseGy.toFixed(1)} size={12} />
            </TableCell>
            <TableCell>
                <CopyField label={row.meanDoseGy.toFixed(1)} size={12} />
            </TableCell>
        </TableRow>
    );
}
